export default (currency) => {
  const temp = currency.toString().replace(/[^0-9.-]+/g, "");
  const parsedValue = parseFloat(temp);

  return isNaN(parsedValue)
    ? 0
    : Math.round((parsedValue + Number.EPSILON) * 100) / 100;
};
